import {
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,
  setDoc,
  updateDoc,
  query,
  where,
  orderBy,
  limit,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../firebase';

// Get or create message thread
export const getMessageThread = async (threadId) => {
  const threadDoc = await getDoc(doc(db, 'messages', threadId));
  if (!threadDoc.exists()) {
    return null;
  }
  return { id: threadDoc.id, ...threadDoc.data() };
};

// Get messages for a thread
export const getThreadMessages = async (threadId) => {
  const messagesRef = collection(db, 'messages', threadId, 'items');
  const q = query(messagesRef, orderBy('timestamp', 'asc'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }));
};

// Send message
export const sendMessage = async (threadId, messageData) => {
  const messagesRef = collection(db, 'messages', threadId, 'items');
  const docRef = await addDoc(messagesRef, {
    ...messageData,
    timestamp: Timestamp.now(),
    read: false,
  });

  // Update thread's last message
  const threadRef = doc(db, 'messages', threadId);
  await updateDoc(threadRef, {
    lastMessage: {
      ...messageData,
      id: docRef.id,
      timestamp: Timestamp.now(),
      read: false,
    },
    updatedAt: Timestamp.now(),
  });

  return docRef.id;
};

// Get user's message threads
export const getUserThreads = async (userId) => {
  const threadsRef = collection(db, 'messages');
  const q = query(
    threadsRef,
    where('participants', 'array-contains', userId),
    orderBy('updatedAt', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }));
};

// Helper to create thread ID from booking
export const createThreadIdFromBooking = (bookingId) => {
  return `booking_${bookingId}`;
};

// Create or get message thread for a booking
export const getOrCreateBookingThread = async (bookingId, participants) => {
  const threadId = createThreadIdFromBooking(bookingId);
  const threadDoc = await getDoc(doc(db, 'messages', threadId));
  
  if (threadDoc.exists()) {
    return { id: threadDoc.id, ...threadDoc.data() };
  }
  
  // Create new thread
  const threadRef = doc(db, 'messages', threadId);
  await setDoc(threadRef, {
    bookingId,
    participants,
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
  });
  
  return { id: threadId, bookingId, participants, createdAt: Timestamp.now(), updatedAt: Timestamp.now() };
};

